(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wavvve-series-card-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wavvve-card-gallery')) {
    customElements.define('wavvve-card-gallery', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-step]');
          if (!button) return;
          event.preventDefault();
          event.stopPropagation();
          const track = this.querySelector('[data-track]');
          track.scrollBy({ left: track.clientWidth * Number(button.dataset.step), behavior: 'smooth' });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
